// plugins/notistack.tsx
import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const baseOptions: ToastOptions = {
    position: 'top-right',
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    autoClose: 1000,
    theme: 'colored',
};

const notistack = {
    success: (message: string, options?: ToastOptions) =>
        toast.success(message, {
            ...baseOptions,
            className: 'bg-success text-white rounded shadow',
            ...options,
        }),

    error: (message: string, options?: ToastOptions) =>
        toast.error(message, {
            ...baseOptions,
            className: 'bg-danger text-white rounded shadow',
            ...options,
        }),

    info: (message: string, options?: ToastOptions) =>
        toast.info(message, {
            ...baseOptions,
            className: 'bg-info text-white rounded shadow',
            ...options,
        }),

    warning: (message: string, options?: ToastOptions) =>
        toast.warn(message, {
            ...baseOptions,
            className: 'bg-warning text-dark rounded shadow',
            ...options,
        }),

    notifyFromApi: (response: any) => {
        const { status, message } = response || {};
        if (status === 200) {
            notistack.success(message || 'Success');
        } else {
            notistack.error(message || 'Something went wrong');
        }
    }
};

export default notistack;
